module.exports = __webpack_public_path__ + "img/Lego_Adults_sk.e13830e9.png";